import {
  useNormalizer,
} from '@sttedra_ui/framework';

import RegisterApplicationsConsolidationApiResponseModel
  from './register-applications-consolidation.api-response-model';

const {
  getString,
  getNumber,
  getObjectFilled,
} = useNormalizer();

class RegisterApplicationsApiResponseModel {
  // #region Props
  identification;
  name;
  surname;
  secondSurname;
  email;
  phone;
  birthDate;
  stateId;
  stateCode;
  registeredDate;
  applicationRegistrationCode;
  consolidatedRegister;
  // #endregion

  constructor(data) {
    this.identification = getString(data?.identification);
    this.name = getString(data?.name);
    this.surname = getString(data?.surname);
    this.secondSurname = getString(data?.secondSurname);
    this.email = getString(data?.email);
    this.phone = getString(data?.phone);
    this.birthDate = getString(data?.birthDate);
    this.stateId = getNumber(data?.stateId);
    this.stateCode = getString(data?.stateCode);
    this.stateDescription = getString(data?.stateDescription);
    this.registeredDate = getString(data?.registeredDate);
    this.applicationRegistrationCode = getString(data?.applicationRegistrationCode);
    this.consolidatedRegister = this.getConsolidatedRegister(data?.consolidatedRegister);
  }

  getConsolidatedRegister(value) {
    if (!getObjectFilled(value)) return null;
    return new RegisterApplicationsConsolidationApiResponseModel(value);
  }
}

export default RegisterApplicationsApiResponseModel;
